const resolveReportData = args => {
    const {
        stopClick = true,
        click = false,
        onceClick = false,
        onceImpression = true,
        impression = true,
        data = null
    } = args;

    return {
        data,
        hasClick: click,
        hasImpression: impression,
        isOnceClick: onceClick,
        isOnceImpression: onceImpression,
        isStopClick: stopClick
    };
};
let observe = null;
const initReport = (el, binding, mreport) => {
    const value = binding.value || {};
    const {data, hasClick, isStopClick, isOnceClick, isOnceImpression, hasImpression} = resolveReportData(value);
    if (!data) {
        return;
    }
    el.reportData = data;
    el.isClick = false;
    if (hasClick) {
        el.onclick = e => {
            if (isStopClick) {
                e.stopPropagation();
            }
            if (mreport && !e.currentTarget.isClick) {
                mreport.report('click', e.currentTarget.reportData);
                if (isOnceClick) {
                    e.currentTarget.isClick = true;
                }
            }
        };
    }
    if (!observe) {
        observe = new IntersectionObserver(
            entries => {
                let i = entries.length - 1;
                while (i >= 0) {
                    const {target, isIntersecting} = entries[i];
                    if (mreport && isIntersecting) {
                        mreport.report('impression', target.reportData);
                        if (isOnceImpression) {
                            observe.unobserve(target);
                        }
                    }
                    i--;
                }
            },
            {
                threshold: 0.5
            }
        );
    }
    if (hasImpression) {
        observe.observe(el);
    }
};
const getDirectiveConfigV2 = mreport => {
    return {
        inserted: function (el, binding) {
            initReport(el, binding, mreport);
        }
    };
};
const getDirectiveConfigV3 = mreport => {
    return {
        mounted: function (el, binding) {
            initReport(el, binding, mreport);
        }
    };
};

export default {
    install(vue, {mreport} = {}) {
        const version = vue.version.substr(0, 1);
        if (Number(version) === 2) {
            const isInstalled = vue.prototype.$mreportInstalled;

            if (isInstalled || !mreport) {
                return;
            }

            vue.directive('report', getDirectiveConfigV2(mreport));
            vue.prototype.$mreportInstalled = true;
            return;
        }
        if (Number(version) === 3) {
            const isInstalled = vue.$mreportInstalled;

            if (isInstalled || !mreport) {
                return;
            }

            vue.directive('report', getDirectiveConfigV3(mreport));
            vue.$mreportInstalled = true;
        }
    }
};
